import { masterApi } from './api';

export default async function fetchCategoryTreeData({ accessToken }) {
	const res = await masterApi.get('/category', {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	});

	return res?.data;
}
